module.exports = __webpack_public_path__ + "img/ico-ham.089de4a0.svg";